/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function n(n){const t=1/n;return{antialiasing:t,blur:0+t}}export{n as getAntialiasingControls};
